/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

/* React Boostrap */
import Footer from "../../components/main/Footer"
import Basket from "../../components/organisms/Basket"
import { Header } from "../../components/organisms/Header"

/* Components */
import { Topbar } from "../../components/organisms/Topbar"
import { initPdiComponent } from "../../core/service/BusinessLogicService"

/* Utils */
import { loc } from "../../core/utils"
import Button from "./../IdentificationPage/components/Button"
import Order from "./components/Order"
import "./styles.css"
import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"

const OrderPage = (props) => {
  const { tunnelData, history } = props

  const [orders, setOrders] = useState([])
  const [selectedOrder, selectOrder] = useState(null)

  useEffect(() => {
    initPdiComponent("OrderPage")
    setOrders(tunnelData.orders)
  }, [tunnelData.orders])
  const submit = () => {
    props.onSetStep({
      renewalOrder: {
        productName: selectedOrder.productName,
        opl: selectedOrder.opl,
        transactionId: selectedOrder.transactionId
      }
    })
  }

  return (
    <Container fluid className="white-background">
      <Row noGutters>
        <Col className="main-block">
          <Topbar tunnelData={tunnelData} displayToggleButton={true} history={history} />
          <Header tunnelData={tunnelData} />
          <Container>
            {tunnelData.renewalTextFirstBlocOrderPage?.map((text, index) => (
              <div key={index} className="text-center text-width">
                {text}{" "}
              </div>
            ))}
            <br />
          </Container>
          <Container>
            {orders
              ?.filter((o) => o.renewal)
              .sort((a, b) => {
                return (
                  Date.parse(a.dateRenouvellement[1] + "/" + a.dateRenouvellement[2] + "/" + a.dateRenouvellement[0]) -
                  Date.parse(b.dateRenouvellement[1] + " " + b.dateRenouvellement[2] + " " + b.dateRenouvellement[0])
                )
              })
              .map((order, index) => (
                <div key={index}>
                  {" "}
                  <Order order={order} selectedOrder={selectedOrder} selectOrder={selectOrder} />{" "}
                </div>
              ))}
            {orders
              ?.filter((o) => !o.renewal)
              .sort((a, b) => {
                return (
                  Date.parse(a.dateRenouvellement[1] + "/" + a.dateRenouvellement[2] + "/" + a.dateRenouvellement[0]) -
                  Date.parse(b.dateRenouvellement[1] + " " + b.dateRenouvellement[2] + " " + b.dateRenouvellement[0])
                )
              })
              .map((order, index) => (
                <div key={index}>
                  {" "}
                  <Order order={order} selectOrder={selectOrder} />{" "}
                </div>
              ))}
            <br />
          </Container>
          <Container className="center-container">
            <Button
              id="submit-button"
              className=""
              disabled={!selectedOrder}
              hidden={!selectedOrder}
              variant="success"
              onClick={submit}
            >
              {loc`Renew Order`}
            </Button>
          </Container>

          <Container>
            <br />
            {tunnelData.renewalTextSecondBlocOrderPage?.map((text, index) => (
              <div key={index} className="text-center text-width">
                {text}{" "}
              </div>
            ))}
            <br />
          </Container>

          <Container className="center-container">
            <Button id="validate-button" type="submit" onClick={() => props.onSetStep()}>
              {loc`New Order`}
            </Button>
          </Container>

          <Col md={{ span: 3, offset: 1 }}>
            <Button href={tunnelData.shopUrl} variant="outline-primary" className="ico-back-small-before">
              {loc("Back to shop")}
            </Button>
          </Col>
          <Container>
            <Footer tunnelData={tunnelData} />
          </Container>
        </Col>

        <Container className="aside-block d-none d-lg-block d-xl-block" lg={4}>
          <Basket tunnelData={tunnelData || null} />
        </Container>
      </Row>
    </Container>
  )
}

export default OrderPage
